module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("My Location(s)")]), _vm._v(" "), _c('p', {
    staticClass: "mb2"
  }, [_vm._v("Here you can put locations where you practice so we can help identify you easier.")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.editDetails || false) ? _c('module-form', {
    attrs: {
      "fields": _vm.fields,
      "form-id": "dentist-location",
      "button-size": "m",
      "button": "primary",
      "submit": _vm.submitLabel,
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  }, [_c('module-button', {
    attrs: {
      "slot": "submit-extras",
      "button": "tertiary",
      "size": "m",
      "type": "button",
      "label": "Cancel"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editLocation()
      }
    },
    slot: "submit-extras"
  }), _vm._v(" "), _c('div', {
    staticClass: "location__remove mt2",
    attrs: {
      "slot": "submit-extras"
    },
    slot: "submit-extras"
  }, [(!_vm.isNewLocation) ? _c('module-link', {
    staticClass: "location__link small fw-bold",
    attrs: {
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeLocation()
      }
    }
  }, [_vm._v("Remove Location")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.editDetails) ? _c('div', {
    staticClass: "locations"
  }, [(!_vm.hasLocations) ? _c('p', {
    staticClass: "mt mb2"
  }, [_vm._v("You have not added your location yet, click below to add your address")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.locations), function(location, index) {
    return _c('div', {
      key: index,
      staticClass: "locations__location"
    }, [_c('div', {
      staticClass: "location__title"
    }, [_c('h4', {
      staticClass: "h4 mt0 mb0"
    }, [_vm._v(_vm._s(location.name))]), _vm._v(" "), _c('module-link', {
      staticClass: "location__link small fw-bold",
      nativeOn: {
        "click": function($event) {
          _vm.editLocation(location.id)
        }
      }
    }, [_vm._v("Edit this location")])], 1), _vm._v(" "), _c('module-detail-list', {
      attrs: {
        "items": {
          'Address Line One': location.address_1,
          'Address Line Two': location.address_2,
          'City': location.city,
          'State': location.state,
          'ZIP': location.zipcode,
        }
      }
    })], 1)
  }), _vm._v(" "), _c('module-button', {
    attrs: {
      "size": "m",
      "level": "secondary",
      "button": "primary",
      "label": "Add Location"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editLocation()
      }
    }
  })], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64387717"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/profile/Locations.vue
// module id = 348
// module chunks = 0